import { FC } from 'react'
import { CardCollectionComponentDto } from '~/modules/CardCollections/Infrastructure/CardCollectionComponentDto'
import styles from '~/modules/CardCollections/Infrastructure/Components/CardCollectionCard.module.scss'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { ProgressBar } from '~/modules/Shared/Infrastructure/Components/ProgressBar'

interface Props {
  cardCollection: CardCollectionComponentDto
}
export const CardCollectionCard: FC<Props> = ({ cardCollection }) => {
  const { t } = useTranslation('card_collections')
  let availableCards = null

  if (cardCollection.obtainableCards > 0) {
    availableCards = (
      <span className={ styles.cardCollectionCard__availables }>
        <span className={ styles.cardCollectionCard__availableCardBullet }> </span>
        { cardCollection.obtainableCards } { t('available_card', { count: cardCollection.obtainableCards }) }
      </span>
    )
  }
  const progress = cardCollection.obtainedCards * 100 / cardCollection.availableCards

  return (
    <Link href={ `/my-collection/series/${cardCollection.id}` } passHref>
      <div className={ styles.cardCollectionCard__container }>
        <img
          className={ styles.cardCollectionCard__logo }
          src={ cardCollection.organizerLogo ?? undefined }
          alt='logo'
        />
        <div className={ styles.cardCollectionCard__details }>
          { t('card_title') }
        </div>
        <h2 className={ styles.cardCollectionCard__title }>
          { cardCollection.name }
        </h2>
        <div className={ styles.cardCollectionCard__cardAmount }>
          <ProgressBar progress={ progress }/>
          { cardCollection.obtainedCards }/{ cardCollection.availableCards }
        </div>
        { availableCards }
      </div>
    </Link>
  )
}
